import React, { useState } from 'react';
import { HumanResourcesHomePage, HREmployeesModule, HRPositionsModule } from './HumanResourcesGear';

const HumanResourcesGearPage = ({ currentUser, onBackToGears }) => {
  const [currentPage, setCurrentPage] = useState('home');

  switch (currentPage) {
    case 'home':
      return <HumanResourcesHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
    case 'employees':
      return <HREmployeesModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    case 'hr-positions':
      return <HRPositionsModule onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    default:
      return <HumanResourcesHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
  }
};

export default HumanResourcesGearPage;
